module.exports = __webpack_public_path__ + "img/猪头.7e8b314f.png";